import { IconButton } from "@amzn/storm-ui";
import { pencil, ellipsisH } from "@amzn/storm-ui-icons";
import Joyride from "react-joyride";

import { useQuickFilterTour } from "../../../../hooks/useQuickFilterTour";
import { StormTouringTooltip } from "../../../touring/common/StormTouringTooltip";
import { DEFAULT_TOUR_STYLES } from "../../../touring/common/tour.constants";

export const QuickFilterTour = (): JSX.Element => {
    const { showTour, completeTour } = useQuickFilterTour();

    return (
        <Joyride
            continuous={true}
            showProgress={true}
            showSkipButton={true}
            steps={[
                {
                    target: '[data-tour-id="quick-filter-dropdown"]',
                    content: (
                        <div>
                            <strong>Save your preferred filters</strong> to
                            access your favorite content easily.
                        </div>
                    ),
                    disableBeacon: true,
                },
                {
                    target: '[data-testid="unified-filter-dropdown-UNIFIED_TYPE"]',
                    content: (
                        <div>
                            <strong>Select your filters. </strong>
                            Choose from any of the suggested filters or add new
                            filters using the “Add filter” button.
                        </div>
                    ),
                    placement: "right",
                },
                {
                    target: '[data-tour-id="quick-filter-dropdown"]',
                    content: (
                        <div>
                            Click "Save Filters".
                            <br />
                            Name your quick filter and apply to only your
                            current account or across your Salesforce book of
                            business.
                        </div>
                    ),
                    disableOverlay: true,
                },
                {
                    target: '[data-tour-id="quick-filter-dropdown"]',
                    content: (
                        <div>
                            Access your saved filters by clicking the{" "}
                            <IconButton
                                icon={ellipsisH}
                                label="dropdown"
                                variant="transparent"
                                disabled
                                style={{
                                    display: "inline",
                                    padding: 0,
                                    minWidth: "auto",
                                }}
                            />
                            .<br />
                            Click on your saved filter to apply.
                            <br />
                            Click the{" "}
                            <IconButton
                                icon={pencil}
                                label="edit"
                                variant="transparent"
                                disabled
                                style={{
                                    display: "inline",
                                    padding: 0,
                                    minWidth: "auto",
                                }}
                            />
                            to edit your saved filter.
                        </div>
                    ),
                },
            ]}
            run={showTour}
            tooltipComponent={StormTouringTooltip}
            callback={(data) => {
                if (data.status === "finished" || data.status === "skipped") {
                    completeTour();
                }
            }}
            styles={DEFAULT_TOUR_STYLES}
        />
    );
};
